import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faTag, faPlay } from "@fortawesome/pro-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { profileInfo } from "../../store";
import { colors } from "../../styles/colors";

const Tools: React.FC<{ toggle: () => void }> = ({ toggle }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { t } = useTranslation();
  const open = Boolean(anchorEl);
  const location = useLocation();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const profile = useSelector(profileInfo);

  const theme = createTheme({
    components: {
      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: colors.default_text,
            fontFamily: "Inter,sans-serif",
            ":hover": {
              backgroundColor: "white",
            },
            "&.menu-item-content:hover": {
              color: colors.default_highlight,
              backgroundColor: "white",
              "& .icon": {
                color: colors.default_highlight,
              },
              "& .help": {
                color: colors.default_highlight,
              },
            },
            "&.Mui-selected": {
              color: colors.default_highlight,
              backgroundColor: "white",
              "& .icon": {
                color: colors.default_highlight,
              },
              "& .help": {
                color: colors.default_highlight,
              },
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: colors.default_text,
            fontFamily: "Inter,sans-serif",
            padding: "0px",
            marginLeft: "-12px",
            fontWeight: "500",
            textTransform: "capitalize",
            fontSize: "14px",
            ":hover": {
              color: colors.default_highlight,
              backgroundColor: "white",
              "& .icon": {
                color: colors.default_highlight,
              },
              "& .help": {
                color: colors.default_highlight,
              },
            },
            ":focus": {
              backgroundColor: "white",
            },
            "&[aria-selected=true]": {
              color: colors.default_highlight,
              "& .icon": {
                color: colors.default_highlight,
              },
              "& .help": {
                color: colors.default_highlight,
              },
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        aria-selected={location.pathname.includes("/tools")}
        onClick={handleClick}
      >
        {t("Import register.Tools")}{" "}
      </Button>
      <Menu
        style={{ overflow: "clip" }}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          selected={location.pathname.includes("/tools/imports")}
          onClick={handleClose}
          className="menu-item-content text-default-text"
        >
          <Link
            onClick={toggle}
            to="/tools/imports"
            className="text-sm font-medium py-[2px] hover:text-default-highlight w-full inline-block"
          >
            <FontAwesomeIcon
              icon={faDownload}
              className="mr-2 text-ph-menu-gray icon"
            />

            {t("Import register.Imports")}
          </Link>
        </MenuItem>

        {profile.role === "A" && (
          <MenuItem
            selected={location.pathname.includes("/tools/help-videos")}
            onClick={handleClose}
            className="menu-item-content text-default-text"
          >
            <Link
              onClick={toggle}
              to="/tools/help-videos"
              className="text-sm font-medium py-[2px] hover:text-default-highlight w-full inline-block"
            >
              <FontAwesomeIcon
                icon={faPlay}
                className="mr-[14px] text-ph-menu-gray icon"
              />
              {t("Help videos.Help videos")}
            </Link>
          </MenuItem>
        )}

        {(profile.role === "A" || profile.role === "C") && (
          <MenuItem
            selected={location.pathname.includes("/tools/tagging-tool")}
            onClick={handleClose}
            className="menu-item-content text-default-text"
          >
            <Link
              onClick={toggle}
              to="/tools/tagging-tool"
              className="text-sm font-medium py-[2px] hover:text-default-highlight w-full inline-block"
            >
              <FontAwesomeIcon
                icon={faTag}
                className="mr-3 text-ph-menu-gray icon"
              />
              {t("Tagging tool.Tagging tool")}
            </Link>
          </MenuItem>
        )}
      </Menu>
    </ThemeProvider>
  );
};

export default Tools;
